import LocalStorageService from '@/services/local-storage.service'
import HttpService from '@/services/http.service'
import axiosApiInstance from '@/services/api'

export const LOCAL_STORAGE_TOKEN = 'accessToken'
export const LOCAL_STORAGE_DEVICE_ID = 'deviceId'
export const LOCAL_STORAGE_REFRESH_TOKEN = 'refreshToken'
export const LOCAL_STORAGE_EMAIL = 'email'

class TokenService {
	constructor({ LocalStorageService, HttpService, axiosApiInstance }) {
		this.localStorageService = LocalStorageService
		this.httpService = HttpService
		this.axios = axiosApiInstance
	}

	saveAccessToken(token) {
		this.httpService.setAuthorizationHeader(token)
		this.setAccessTokenToStorage(token)
	}
	saveDeviceId(deviceId) {
		this.setDeviceIdToStorage(deviceId)
	}

	setAccessTokenToStorage(token) {
		this.localStorageService.set(LOCAL_STORAGE_TOKEN, token)
	}
	setDeviceIdToStorage(deviceId) {
		this.localStorageService.set(LOCAL_STORAGE_DEVICE_ID, deviceId)
	}

	setEmailToStorage(email) {
		this.localStorageService.set(LOCAL_STORAGE_EMAIL, email)
	}

	saveEmail(email) {
		this.setEmailToStorage(email)
	}

	getAccessTokenFromBody(response) {
		return response?.data['access_token']
	}

	getAccessTokenFromStorage() {
		return this.localStorageService.get(LOCAL_STORAGE_TOKEN)
	}

	getDeviceIdFromStorage() {
		return this.localStorageService.get(LOCAL_STORAGE_DEVICE_ID)
	}

	getRefreshTokenFromStorage() {
		return this.localStorageService.get(LOCAL_STORAGE_REFRESH_TOKEN)
	}

	getEmailFromStorage() {
		return this.localStorageService.get(LOCAL_STORAGE_EMAIL)
	}

	removeDeviceId() {
		this.localStorageService.remove(LOCAL_STORAGE_DEVICE_ID)
	}

	clearStorageTokens() {
		this.localStorageService.remove(LOCAL_STORAGE_TOKEN)
		this.localStorageService.remove(LOCAL_STORAGE_REFRESH_TOKEN)
		this.localStorageService.remove(LOCAL_STORAGE_EMAIL)
	}

	async refreshToken(error) {
		let subscribers = []
		let isAlreadyFetchingAccessToken = false

		const onAccessTokenFetched = (access_token) => {
			subscribers.forEach((callback) => callback(access_token))
			isAlreadyFetchingAccessToken = false
			subscribers = []
		}

		const addSubscriber = (callback) => {
			subscribers.push(callback)
		}

		try {
			const { response: errorResponse } = error
			const refreshToken = this.getRefreshTokenFromStorage()

			if (!refreshToken) return Promise.reject(error)
			const retryOriginalRequest = new Promise((resolve) => {
				addSubscriber((access_token) => {
					const originalRequest = errorResponse.config

					this.httpService.setAuthorizationHeader(access_token, originalRequest.headers)
					resolve(this.axios(originalRequest))
				})
			})

			if (!isAlreadyFetchingAccessToken) {
				isAlreadyFetchingAccessToken = true

				onAccessTokenFetched(true)
			}
			return retryOriginalRequest
		} catch (err) {
			return Promise.reject(err)
		}
	}
}

export default new TokenService({
	LocalStorageService,
	HttpService,
	axiosApiInstance,
})
